var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n        このサイトはお使いのブラウザー（Internet Explorer）には対応していません。Google Chromeなどをご利用ください。\n")])}
var staticRenderFns = []

export { render, staticRenderFns }